import { OdataFilters, queryCollection } from "helpers/reqparams";
import { alertRequest, body, downloadFileHandler, request } from "services/request";

const resource = "api/emergencyArea";
const bidEmergencyAreaPoints = "api/bidEmergencyAreaPoints";
const defaultQuery = {
    orderBy: "id desc",
};

const index = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: { ...preparedFilter }, ...defaultQuery });
    return request(`${resource}/getPoints${query}`, { method: "GET" }, { countInHeaders: true });
};

const getListExcel = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: { ...preparedFilter }, ...defaultQuery });
    return request(`${resource}/getListExcel?${query}`, { method: "GET" }, { withoutMiddleware: true }).then((res) =>
        downloadFileHandler(res, "Аварийные участки.xlsx"),
    );
};

const apply = (params: {}) => alertRequest(`${resource}/applyPoint`, body(params));

const delItem = (params: {}) => alertRequest(`${resource}/deletePoint`, body(params));

const getItem = ({ id }: { id: number }) => request(`${resource}/getPoint/${id}`, { method: "GET" });

const getBidItem = (bidId: number) => request(`${bidEmergencyAreaPoints}/getPoints/${bidId}`, { method: "GET" });

export { apply, delItem, index, getItem, getBidItem, getListExcel };
